const f = r => {
  var t;
  if (!((t = r.current) != null && t.children)) return [];
  const e = r.current.children;
  return Array.from(e).map(n => {
    const {
      offsetLeft: c,
      offsetWidth: s
    } = n;
    return c + s;
  });
};
export { f as getInnerElementsSizes };